export const API_ERROR_MESSAGE = 'Technical Error'

/**
 * Red toast shown when a widget/API encounters an error. Displayed 3–4s at bottom.
 */
export const API_ERROR_TOAST_MESSAGE =
  'We have encountered Technical Error please try again after some time'

/** Toast for 422, 404, 403. Same grey styling as other non-500 toasts. */
export const UNAUTHORIZED_ACCESS_TOAST_MESSAGE =
  'Unauthorized access. You do not have permission to access.'

/** For overlay charts: error message with warning icon, red when used with noData.style.color */
export const API_ERROR_DISPLAY = '\u26A0 ' + API_ERROR_MESSAGE

export const TABLE_API_ERROR_MESSAGE = API_ERROR_MESSAGE

export const NO_DATA_AVAILABLE = 'No data available'
